// extracted by mini-css-extract-plugin
export default {"root":"DropNotify__root--2TiAI","fadeIn":"DropNotify__fadeIn--TMMLb","root_error":"DropNotify__root_error--2H5td","root_warning":"DropNotify__root_warning--3pvxG"};